module.exports = __webpack_public_path__ + "static/media/speaker_icon.19681504.svg";